import { useRef, useState } from "react";
import { FileProcessModel } from "../../../hooks/community/models/FileProcessModel";
import { CommentsMessagesModel } from "../models/CommentsMessagesModel";
import { showErrorAlert } from "../../../helpers/alert";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { defaultProfileImage } from "../../../utils/constants";
import { handleImageErrorProfile } from "../../../utils/UtilsFiles";
import { CommunityAttachment } from "../../community/components/CommunityAttachment";

type Props = {
    onSendComment: (value: string) => Promise<void> | void;
    cleanReply: () => void;
    reply?: CommentsMessagesModel | null;
    files: FileProcessModel[];
    OnRemoveFile: (file: FileProcessModel) => void;
    onAddFile: (file: File) => void;
    editingMessage?: CommentsMessagesModel | null;
    onCancelEdit?: () => void;
}
export const CommentsMessageInput = ({ onSendComment, cleanReply, reply, files, OnRemoveFile, onAddFile, editingMessage, onCancelEdit }: Props) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [value, setValue] = useState('');
    const [isSending, setIsSending] = useState(false);

    // Sync content if editingMessage changes
    const lastEditedMsgId = useRef<string | number | undefined>(undefined);
    if (editingMessage && editingMessage.id !== lastEditedMsgId.current) {
        setValue(editingMessage.content);
        lastEditedMsgId.current = editingMessage.id;
    } else if (!editingMessage && lastEditedMsgId.current !== undefined) {
        setValue('');
        lastEditedMsgId.current = undefined;
    }

    const handleInput = () => {
        const el = textareaRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = el.scrollHeight + 'px';
    };

    const _handleSendComment = async () => {
        if(!value)
            return showErrorAlert({ title: '', message: 'The message field cannot be empty.' });
        
        setIsSending(true);
        try {
            await onSendComment(value);
            setValue('');
            if (textareaRef.current) {
                textareaRef.current.style.height = 'auto';
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsSending(false);
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter') {
            if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                const target = e.currentTarget;
                const start = target.selectionStart;
                const end = target.selectionEnd;
                const val = target.value;
                const newValue = val.substring(0, start) + '\n' + val.substring(end);
                setValue(newValue);
                setTimeout(() => {
                    target.selectionStart = target.selectionEnd = start + 1;
                    if (textareaRef.current) {
                        textareaRef.current.style.height = 'auto';
                        textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
                    }
                }, 0);
            } else {
                e.preventDefault();
                _handleSendComment();
            }
        }
    };

    return (
        <div className="community-details__actions">
            { files.map((f, i) => (
                <div key={i} style={{ width: '100%', padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#f0f0f0' }}>
                    <span> { f.file.name } </span>
                    <button onClick={() => OnRemoveFile(f)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 32 32" fill="none">
                            <path d="M15.9998 29.3334C23.3332 29.3334 29.3332 23.3334 29.3332 16.0001C29.3332 8.66675 23.3332 2.66675 15.9998 2.66675C8.6665 2.66675 2.6665 8.66675 2.6665 16.0001C2.6665 23.3334 8.6665 29.3334 15.9998 29.3334Z" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.2266 19.7734L19.7733 12.2268" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.7733 19.7734L12.2266 12.2268" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            ))}
            { reply && (
                <div className="community-comment__info__reply" style={{ position: 'relative' }}>
                    <img src={toAbsoluteUrl(reply.avatar) || defaultProfileImage} onError={handleImageErrorProfile} alt={reply.author} />
                    <span className="author">{reply.author}</span>
                    { reply.isMine && (<div className="host"><span>HOST</span></div>) }
                    <span className="content-preview">{reply.content}</span>

                    <button style={{ position: 'absolute', top: '5px', right: '5px' }} onClick={cleanReply}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 32 32" fill="none">
                            <path d="M15.9998 29.3334C23.3332 29.3334 29.3332 23.3334 29.3332 16.0001C29.3332 8.66675 23.3332 2.66675 15.9998 2.66675C8.6665 2.66675 2.6665 8.66675 2.6665 16.0001C2.6665 23.3334 8.6665 29.3334 15.9998 29.3334Z" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.2266 19.7734L19.7733 12.2268" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.7733 19.7734L12.2266 12.2268" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            )}
            { editingMessage && (
                <div style={{ width: '100%', padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#FFF5F8', borderLeft: '3px solid #F1416C' }}>
                    <span style={{ fontSize: '13px', color: '#F1416C' }}>Modo edición: { editingMessage.content.slice(0, 40) }...</span>
                    <button onClick={onCancelEdit} style={{ background: 'none', border: 'none', color: '#808080', fontSize: '12px', cursor: 'pointer' }}>
                        Cancelar
                    </button>
                </div>
            )}
            <div className="community-details__actions__tools">
                <CommunityAttachment
                    onAddFile={onAddFile}
                />

                 <textarea
                    ref={textareaRef}
                    placeholder={editingMessage ? "Edit message..." : "Send Message"}
                    rows={1}
                    style={{ resize: 'none', overflow: 'hidden' }}
                    onInput={handleInput}
                    onKeyDown={handleKeyDown}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    disabled={isSending}
                />

                <button className="send" onClick={_handleSendComment} disabled={isSending} style={{ opacity: isSending ? 0.5 : 1, cursor: isSending ? 'not-allowed' : 'pointer' }}>
                    {isSending ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: '1.2rem', height: '1.2rem', color: '#151515' }}></span>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M9.51026 4.22867L18.0702 8.50867C21.9102 10.4287 21.9102 13.5687 18.0702 15.4887L9.51026 19.7687C3.75026 22.6487 1.40026 20.2887 4.28026 14.5387L5.15026 12.8087C5.37026 12.3687 5.37026 11.6387 5.15026 11.1987L4.28026 9.45867C1.40026 3.70867 3.76026 1.34867 9.51026 4.22867Z" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5.43994 12H10.8399" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    )}
                </button>
            </div>
        </div>
    )
}